import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { ManagementMainPanelTitleComponent } from '@connect-services/client/components/management/management-main-panel-title/management-main-panel-title.component';
import { ManagementNoPermissionComponent } from '@connect-services/client/pages/management/no-permission/management-no-permission.component';
import { RolesListComponent } from '@connect-services/client/pages/management/organization/users-roles/roles-list/roles-list.component';
import { UsersListComponent } from '@connect-services/client/pages/management/organization/users-roles/users-list/users-list.component';
import { OrganizationAccessPermissionsService } from '@connect-services/client/services/organization-access-permissions.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ManagementMainPanelTitleComponent,
        ManagementNoPermissionComponent,
        RolesListComponent,
        UsersListComponent,
    ],
    selector: 'app-users-roles',
    templateUrl: './users-roles.component.html',
})
export class UsersRolesComponent {
    protected readonly accessOrganizationPermissions = computed(() => {
        return {
            canAccessRole: this.organizationAccessPermissionsService.canAccessRole(),
            canAccessUser: this.organizationAccessPermissionsService.canAccessUser(),
            label: this.organizationAccessPermissionsService.usersRolesLabelKey(),
        };
    });

    private readonly organizationAccessPermissionsService = inject(OrganizationAccessPermissionsService);
}
